/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { PotentialChangeOrdersControllerFindOneQueryResponse, PotentialChangeOrdersControllerFindOnePathParams, PotentialChangeOrdersControllerFindOneQueryParams, PotentialChangeOrdersControllerFindOne400, PotentialChangeOrdersControllerFindOne401, PotentialChangeOrdersControllerFindOne403, PotentialChangeOrdersControllerFindOne404 } from "../../models/changeOrdersController/PotentialChangeOrdersControllerFindOne";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { potentialChangeOrdersControllerFindOne } from "../../clients/change-ordersService/potentialChangeOrdersControllerFindOne";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const potentialChangeOrdersControllerFindOneQueryKey = (id: PotentialChangeOrdersControllerFindOnePathParams["id"], params: PotentialChangeOrdersControllerFindOneQueryParams = {}) => [{
  url: '/api/v1/potential-change-orders/:id',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type PotentialChangeOrdersControllerFindOneQueryKey = ReturnType<typeof potentialChangeOrdersControllerFindOneQueryKey>;
export function potentialChangeOrdersControllerFindOneQueryOptions(id: PotentialChangeOrdersControllerFindOnePathParams["id"], params?: PotentialChangeOrdersControllerFindOneQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = potentialChangeOrdersControllerFindOneQueryKey(id, params);
  return queryOptions<PotentialChangeOrdersControllerFindOneQueryResponse, ResponseErrorConfig<PotentialChangeOrdersControllerFindOne400 | PotentialChangeOrdersControllerFindOne401 | PotentialChangeOrdersControllerFindOne403 | PotentialChangeOrdersControllerFindOne404>, PotentialChangeOrdersControllerFindOneQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return potentialChangeOrdersControllerFindOne(id, params, config);
    }
  });
}

/**
 * @summary Get a potential change order by id
 * {@link /api/v1/potential-change-orders/:id}
 */
export function usePotentialChangeOrdersControllerFindOne<TData = PotentialChangeOrdersControllerFindOneQueryResponse, TQueryData = PotentialChangeOrdersControllerFindOneQueryResponse, TQueryKey extends QueryKey = PotentialChangeOrdersControllerFindOneQueryKey>(id: PotentialChangeOrdersControllerFindOnePathParams["id"], params?: PotentialChangeOrdersControllerFindOneQueryParams, options: {
  query?: Partial<QueryObserverOptions<PotentialChangeOrdersControllerFindOneQueryResponse, ResponseErrorConfig<PotentialChangeOrdersControllerFindOne400 | PotentialChangeOrdersControllerFindOne401 | PotentialChangeOrdersControllerFindOne403 | PotentialChangeOrdersControllerFindOne404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? potentialChangeOrdersControllerFindOneQueryKey(id, params);
  const query = useQuery({
    ...potentialChangeOrdersControllerFindOneQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<PotentialChangeOrdersControllerFindOne400 | PotentialChangeOrdersControllerFindOne401 | PotentialChangeOrdersControllerFindOne403 | PotentialChangeOrdersControllerFindOne404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}